export const TOKEN_RESET = 6
